// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__2ayAr","screen":"styles_screen__QwBQs","loader":"styles_loader__3pglp","navBar":"styles_navBar__gVZFb","content":"styles_content__1_ax0"};